/** Copyright (C) 2022 Trend Micro Inc. All rights reserved. */

export const uuidByCloudOneStage = (() => {
  let uuid = '0ebb1eb3-5de1-4d7f-8cce-b04607c0c4dd'

  if (window?.location?.hostname?.indexOf('dev-') > -1) {
    uuid = '25c0d06a-cae3-46c9-a62e-3889e69f7118'
  }
  if (window?.location?.hostname?.indexOf('staging-') > -1) {
    uuid = '62209d5a-4e59-408e-a3b9-37879fe15e02'
  }

  return uuid
})()

export const azureLaunchAllInOneStackURL =
  'https://portal.azure.com/#create/Microsoft.Template/uri/https%3A%2F%2Ffile-storage-security.s3.amazonaws.com%2Flatest%2Farm-templates%2FFSS-All-In-One-Template.json'
export const azureLaunchScannerStackURL =
  'https://portal.azure.com/#create/Microsoft.Template/uri/https%3A%2F%2Ffile-storage-security.s3.amazonaws.com%2Flatest%2Farm-templates%2FFSS-Scanner-Stack-Template.json'
export const azureLaunchStorageStackURL =
  'https://portal.azure.com/#create/Microsoft.Template/uri/https%3A%2F%2Ffile-storage-security.s3.amazonaws.com%2Flatest%2Farm-templates%2FFSS-Storage-Stack-Template.json'

export const AZURE_DEPLOY_INPUT_KEYS = [
  'azureScannerStackTenantId',
  'azureScannerStackResourceGroupId',
  'azureStorageStackTenantId',
  'azureStorageStackResourceGroupId',
] as Redux.DeployStackInputKeyName[]
